/**
 * Compare two dates by calendar day in a given time zone (default Europe/Berlin).
 * Uses the time zone via Intl to avoid local vs UTC pitfalls.
 */
export function isSameDay(
    a: Date,
    b: Date,
    timeZone: string = "Europe/Berlin"
): boolean {
    const fmt = new Intl.DateTimeFormat("en-CA", {
        // en-CA yields ISO-like Y-M-D, but we only need a stable day key.
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        timeZone,
    });
    return fmt.format(a) === fmt.format(b);
}